import { InputAdornment, TextField } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useState } from "react";
import DialogIntervaloDate, { TPeriodoOption } from "./DialogIntervaloDate";
import moment, { Moment } from "moment";

export default function DateComIntervalo({
  data,
  onChangeData,
  datePickerView = ["year", "month"],
  formatString = "MM/YYYY",
  labelInput = "Período",
  icon = true,
  error = false,
  helperText = "",
  possuiBtnLimpar = false,
  size = "medium",
}: DateComIntervaloProps) {
  const [openDateModal, setOpenDateModal] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<TPeriodoOption>({
    label: "Periodo customizado",
    dataInicial: moment(),
    dataFinal: moment(),
  });

  let placeholderInput = "";

  if (data.inicial && data.final)
    placeholderInput = `${data?.inicial?.format(
      formatString
    )} até ${data?.final?.format(formatString)}`;

  if (data.inicial || data.final) {
    if (!data.inicial)
      placeholderInput = `até ${data?.final?.format(formatString)}`;
    if (!data.final)
      placeholderInput = `a partir de ${data?.inicial?.format(formatString)}`;
  }

  if (possuiBtnLimpar && !data.inicial && !data.final)
    placeholderInput = "Todos";

  return (
    <>
      <TextField
        {...{ size }}
        fullWidth
        label={labelInput}
        variant="outlined"
        value={placeholderInput}
        onClick={() => setOpenDateModal(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenDateModal(true);
          }
        }}
        slotProps={{
          input: {
            ...(icon && {
              endAdornment: (
                <InputAdornment position="start">
                  <CalendarMonthIcon />
                </InputAdornment>
              ),
              readOnly: true,
            })
          }
        }}
        {...{ error, helperText }}
      />

      {openDateModal && (
        <DialogIntervaloDate
          {...{ datePickerView, formatString, selectedOption, possuiBtnLimpar }}
          fieldValues={data}
          open={openDateModal}
          handleClose={() => setOpenDateModal(false)}
          onSubmit={(obj) => onChangeData(obj)}
          onChangeOption={(option) => setSelectedOption(option)}
        />
      )}
    </>
  );
}

interface DateComIntervaloProps {
  data: TDataObj;
  onChangeData: (arg: TDataObj) => void;
  datePickerView?: TDatePickerView;
  formatString?: string;
  labelInput?: string;
  icon?: boolean;
  error?: boolean;
  helperText?: string;
  possuiBtnLimpar?: boolean;
  size?: "small" | "medium";
}

export type TDatePickerView = Array<"month" | "year" | "day">;

type TDataObj = {
  inicial: Moment | null;
  final: Moment | null;
};
